import { ImageCard } from "./components/ImageCard/ImageCard";
import './App.css';
import axios from "axios";
import { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';


function App() {

  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [tetsArray, setTestArray] = useState([]);
  let [currentIndex, setCurrentIndex] = useState(50);

  useEffect(() => {
    (async () => {
      try {
        const {data: {data}} = await axios.get("data.json");
        console.log(data)
        setData(data);
        setTestArray(data.slice(0, 50))
      }catch(err){
        console.log(err)
      }
    })()
  }, [])

  

  const fetchMoreData = () => {
    if (tetsArray.length >= 10000) {
      setHasMore(false);
      return;
    }
    setTimeout(() => {
      setTestArray(tetsArray.concat(data.slice(currentIndex, currentIndex+50)));
      setCurrentIndex(currentIndex+=50);
    }, 1000);
  };

  console.log("Test Array", tetsArray);

  return (
    <div className="App">
      <h1>Stock Images with Tags</h1>
      <InfiniteScroll
              dataLength={tetsArray.length} 
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
              
            >
              <div className="main">
              {tetsArray.filter(card => !card.tags.trim().toLowerCase().includes("woman")).map((card, index) => (
                <ImageCard card={card} key={index} />
              ))}
              </div>
        </InfiniteScroll>
      
      <footer style={{ textAlign: "center" }}>
        <h2>Scrapped and Made with ❤ </h2>
      </footer>
    </div>
  );
}

export default App;

